export default "__VITE_ASSET__CTZfiBjv__"